import WebApp from '@twa-dev/sdk';
import { create } from 'zustand';
import { applyTheme, telegramScheme } from '../lib/tma';
import { otherTheme, readSavedTheme, resolveTheme, saveTheme, type Theme } from '../lib/theme';

/** window.localStorage, or null where touching it throws (blocked site data). */
function safeLocalStorage(): Storage | null {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

function currentTheme(): Theme {
  return resolveTheme(telegramScheme(), readSavedTheme(safeLocalStorage()));
}

interface ThemeState {
  theme: Theme;
  /** Manual switch from the header; the choice is remembered. */
  toggle(): void;
  /** Telegram changed its scheme: re-resolve against the saved choice. */
  syncTelegram(): void;
}

export const useTheme = create<ThemeState>((set, get) => ({
  theme: currentTheme(),
  toggle() {
    const next = otherTheme(get().theme);
    saveTheme(next, safeLocalStorage());
    applyTheme(next);
    set({ theme: next });
  },
  syncTelegram() {
    const next = currentTheme();
    applyTheme(next);
    set({ theme: next });
  },
}));

/** Applies the resolved theme before the first render and follows Telegram's theme changes. */
export function initTheme(): void {
  useTheme.getState().syncTelegram();
  try {
    WebApp.onEvent('themeChanged', () => useTheme.getState().syncTelegram());
  } catch {
    // Outside Telegram there are no theme events.
  }
}
